import { Menu, MenuButton, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import {
  ArrowDownTrayIcon,
  CheckCircleIcon,
  EyeIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import LibraryRequestKebabMenu from "./LibraryRequestKebabMenu";
import LibraryRequestMenuItem from "./LibraryRequestMenuItem";

export default function LibraryRequestHeaderActions({
  details,
  onPreview,
  onDownload,
  onAccept,
  onReject,
  isResponding,
  isDownloading,
}) {
  const showDocumentMenu = details?.can_preview || details?.can_download;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {details?.can_respond && (
        <Menu as="div" className="relative inline-block text-left">
          <MenuButton
            disabled={isResponding}
            className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-500 disabled:cursor-wait disabled:bg-gray-300"
          >
            {isResponding ? "Saving..." : "Respond"}
            <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
          </MenuButton>
          <MenuItems
            anchor="bottom end"
            portal
            className="z-50 cursor-pointer mt-2 w-48 rounded-md shadow-lg bg-white border border-1 ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <div className="py-1">
              <LibraryRequestMenuItem onClick={onAccept}>
                <CheckCircleIcon className="w-[16px] h-[16px]" />
                <span>Accept</span>
              </LibraryRequestMenuItem>
              <LibraryRequestMenuItem onClick={onReject}>
                <XCircleIcon className="w-[16px] h-[16px]" />
                <span>Reject</span>
              </LibraryRequestMenuItem>
            </div>
          </MenuItems>
        </Menu>
      )}
      {showDocumentMenu && (
        <LibraryRequestKebabMenu>
          {details.can_preview && (
            <LibraryRequestMenuItem onClick={onPreview}>
              <EyeIcon className="w-[16px] h-[16px]" />
              <span>Preview Report</span>
            </LibraryRequestMenuItem>
          )}
          {details.can_download && (
            <LibraryRequestMenuItem onClick={onDownload} disabled={isDownloading}>
              <ArrowDownTrayIcon className="w-[16px] h-[16px]" />
              <span>{isDownloading ? "Downloading..." : "Download Report"}</span>
            </LibraryRequestMenuItem>
          )}
        </LibraryRequestKebabMenu>
      )}
    </div>
  );
}
